import { render, staticRenderFns } from "./_MediaGroupWrapper.vue?vue&type=template&id=faf2f5a2&scoped=true&"
import script from "./_MediaGroupWrapper.vue?vue&type=script&lang=js&"
export * from "./_MediaGroupWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf2f5a2",
  null
  
)

export default component.exports